import React from 'react';

export const  Footer = () =>{
  var currentYear = new Date().getFullYear();
  var startYear = 2008;

  return (
    <footer style={footerStyle}>
      <p>{`© ${startYear} - ${currentYear} Techsa Services Pvt. Ltd.`}</p>
    </footer>
  );
}

const footerStyle = {
  backgroundColor: '#333',
  color: '#fff',
  textAlign: 'center',
  padding: '10px',
};
